import React, { Component } from 'react';
import { connect } from 'react-redux';
import firebase from 'firebase/app';
import { withRouter, Route } from 'react-router-dom';
import muiThemeable from 'material-ui/styles/muiThemeable';
import {
  addMessage,
  loadThread,
  subscribeToThreadMessages,
  subscribeToThreadThreads,
  unsubscribeFromThreadMessages,
  unsubscribeFromThreadThreads,
} from 'actions';
import { isEmpty } from 'lodash';

import Button from 'ui/Button';
import Dialog from 'ui/Dialog';

import Message from './Message';
import SubthreadLI from './SubthreadLI';
import Subthread from './Subthread';
import Composer from './Composer';
import Receipts from './Receipts';
import { isCompositeType } from 'graphql';



const mapStateToProps = (state, ownProps) => {
  const { url, path } = ownProps.match || {};
  const history = ownProps.history;
  const location = ownProps.location;

  const thread = ownProps.thread || state.threads.all[ownProps.threadId] || {};
  const threadId = thread.threadId;
  const userId = state.user.id;


  let recipients = Object.keys(thread.recipients || {})
    .map(id => thread.recipients[id])
    .slice(0, 5)
    .reduce((all, r) => !userId || r.userId !== userId ? [...all, r.name || r.email || r.phone] : all, [])
    .join(', ');
  if(thread.recipients && thread.recipients.length > 5) {
    recipients += ` ...and ${thread.recipients.length - 5} more.`;
  }

  const subject = thread.subject || "(No Subject)";

  const message = thread.message;

  const replies = state.messages.byThread[threadId] || {};

  const allThreads = state.threads.byThread[threadId] || {};
  const threads = {};
  Object.keys(allThreads)
    .map(id => ({...allThreads[id], id}))
    .forEach(thread => {
      if(thread.hasMessages > 1) {
        threads[thread.id] = thread;
      }
    });

  const showReply = thread.canReply !== false;


  // Get all email addresses from recipients who have replied
  const repliedEmails = new Set();
  Object.values(threads).forEach(reply => {
    if (reply.recipients) {
      Object.values(reply.recipients).forEach(recipient => {
        if (recipient.emails) {
          recipient.emails.forEach(email => repliedEmails.add(email));
        }
        if (recipient.email) {
          repliedEmails.add(recipient.email);
        }
      });
    }
  });

  // Count recipients from parent thread who haven't replied
  const unrepliedRecipients = Object.values(thread.recipients || {}).filter(recipient => {
    if (recipient.emails) {
      return !recipient.emails.some(email => repliedEmails.has(email));
    }
    if (recipient.email) {
      return !repliedEmails.has(recipient.email);
    }
    return true; // If no email, consider as unreplied
  });

  const unrepliedCount = thread.parentThreadId ? 0 : unrepliedRecipients.length;

  return {
    url, path, history, location,
    threadId,
    subject,
    recipients,
    message,
    replies,
    parentThread: thread,
    threads,
    showReply,
    unrepliedRecipients,
    unrepliedCount,
    ...ownProps,
  };
};

const mapDispatchToProps = {
  addMessage,
  loadThread,
  subscribeToThreadMessages,
  subscribeToThreadThreads,
  unsubscribeFromThreadMessages,
  unsubscribeFromThreadThreads,
};





class Thread extends Component {

  state = {
    showReceipts: false,
  }

  UNSAFE_componentWillMount() {
    const threadId = this.props.threadId;
    this.props.loadThread(threadId);
    this.props.subscribeToThreadMessages(threadId);
    this.props.subscribeToThreadThreads(threadId);
  }

  componentWillUnmount() {
    const threadId = this.props.threadId;
    this.props.unsubscribeFromThreadMessages(threadId);
    this.props.unsubscribeFromThreadThreads(threadId);
  }



  reply = message => {
    const threadId = this.props.threadId;
    const packId = this.props.packId;
    this.props.addMessage(threadId, {...message, packId});
  }

  toggleReceipts = () => {
    this.setState({
      showReceipts: !this.state.showReceipts
    });
  }

  followUp = () => {
    this.setState({ isConfirmingFollowUp: true });
  }

  cancelFollowUp = () => {
    this.setState({ isConfirmingFollowUp: false });
  }

  confirmFollowUp = async () => {
    this.setState({ 
      isFollowUpSending: true,
    });
    const sendThreadFollowUp = firebase.functions().httpsCallable('sendThreadFollowUp');

    try {
      console.log('sending follow up...', this.props.threadId);
      await sendThreadFollowUp({ threadId: this.props.threadId });
      // await new Promise(r => setTimeout(r, 1500));
      // throw new Error('Test error for follow up dialog');

      this.setState({ 
        isFollowUpSent: true,
        isConfirmingFollowUp: false,
        isFollowUpSending: false,
      });
    } catch (error) {
      console.error('Error sending follow up:', error);
      this.setState({ 
        followUpError: error.message || 'An error occurred while sending the follow up.',
        isConfirmingFollowUp: false,
        isFollowUpSending: false,
      });
    }
    
  }

  render() {
    const {
      path, url, history, location,
      threadId,
      onClose,
      subject,
      recipients,
      receipts,
      message,
      replies,
      unrepliedCount,
      threads,
      showReply,
      // muiTheme:{ palette },
    } = this.props;

    const messageEls = Object.keys(replies)
      .map(id => ({...replies[id], id}))
      .map(m =>
        <Message key={m.id} message={m}/>
      );

    return (
      <div
        className="threadslist-thread">

        <div className="threadslist-thread-subject">{subject}</div>

        {this.state.showReceipts ? (
          <div onClick={this.toggleReceipts}>
            <Receipts threadId={threadId}/>
          </div>
        ) : (
          <div className="threadslist-thread-recipients" onClick={this.toggleReceipts}>
            <span>To {recipients}</span>
            {!isEmpty(receipts) && <span> ...more</span>}
          </div>
        )}

        {unrepliedCount > 0 && (
          <div className="threadslist-thread-recipients-unreplied">
            {unrepliedCount} recipient{unrepliedCount !== 1 ? 's' : ''} {unrepliedCount !== 1 ? 'have' : 'has'} not replied yet.
            <div className="threadslist-thread-recipients-unreplied-followup" onClick={this.followUp}>Resend</div>.
          </div>
        )}

        {message &&
          <div className="threadslist-thread-message">
            <Message message={message}/>
          </div>
        }

        {messageEls.length > 0 &&
          <div className="threadslist-thread-messages">
            {messageEls}
          </div>
        }

        {Object.keys(threads || {}).length > 0 &&
          <div className="threadslist-thread-subthreads">
            <Route path={`${path}/:threadId?`} render={props => {
              const threadId = props.match.params.threadId;
              return Object.keys(threads)
                .map(id => ({id, ...threads[id]}))
                .sort((a, b) => a.dateUpdated < b.dateUpdated ? 1 : -1)
                .map(thread => {
                  if(thread.id === threadId) {
                    return (
                      <Subthread
                        key={thread.id}
                        threadId={threadId}
                        onClose={e => history.replace({pathname:url, state:location.state})}
                      />
                    );
                  }
                  else {
                    return (
                      <SubthreadLI
                        key={thread.id}
                        thread={thread}
                        threadId={thread.id}
                        onSelect={() => history.replace({pathname:`${url}/${thread.id}`, state:location.state})}
                      />
                    );
                  }
                });
            }}/>
          </div>
        }

        {/* {!showReply && unrepliedCount > 0 && (
          <div className="threadslist-followup-button">
            <Button
              label={`Follow up with ${unrepliedCount} recipient${unrepliedCount !== 1 ? 's' : ''} who ${unrepliedCount !== 1 ? "haven't" : "hasn't"} replied`}
              color="#aaa"
              labelStyle={{color:"#aaa"}}
              onClick={this.followUp}
            />
          </div>
        )} */}

        {showReply &&
          <Composer
            className="threadslist-thread-composer"
            threadId={threadId}
            onSend={this.reply}
          />
        }

        {onClose &&
          <Button
            icon="close"
            onClick={e => {
              e.stopPropagation();
              onClose();
            }}
            className="threadslist-thread-close"
          />
        }

        
        <Dialog
          title="Sending Follow Up"
          actions={[
            <Button
              key="cancel"
              label="Nevermind"
              disabled={this.state.isFollowUpSending}
              onClick={this.cancelFollowUp}
              style={{marginRight:8}}
            />,
            <Button
              key="confirm"
              raised={true}
              disabled={this.state.isFollowUpSending}
              label={this.state.isFollowUpSending ? "Sending..." : "Yes"}
              primary={true}
              onClick={this.confirmFollowUp}
            />,
          ]}
          modal={true}
          open={this.state.isConfirmingFollowUp}
          modalStyle={{maxWidth:400}}
          onRequestClose={this.cancelFollowUp}>
  
          <div>
            <p>Are you sure you want to resend this message to {unrepliedCount} recipients?</p>
          </div>
  
        </Dialog>

        <Dialog
          title="Follow Up Sent"
          actions={[
            <Button
              key="confirm"
              raised={true}
              label="Ok"
              primary={true}
              onClick={() => this.setState({ isFollowUpSent: false })}
            />,
          ]}
          modal={true}
          open={this.state.isFollowUpSent}
          modalStyle={{maxWidth:400}}
          onRequestClose={() => this.setState({ isFollowUpSent: false })}>
  
          <div>
            <p>The message has been resent.</p>
          </div>
  
        </Dialog>

        <Dialog
          title="Error Sending Follow Up"
          actions={[
            <Button
              key="close"
              raised={true}
              label="Ok"
              primary={true}
              onClick={() => this.setState({ followUpError: null })}
            />,
          ]}
          modal={true}
          open={!!this.state.followUpError}
          modalStyle={{maxWidth:400}}
          onRequestClose={() => this.setState({ followUpError: null })}>
  
          <div>
            <p>{this.state.followUpError}</p>
          </div>
  
        </Dialog>

      </div>
    );
  }
}




export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(
    muiThemeable()(
      Thread
    )
  )
);